import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
export function HowItWorksSection() {
  const {
    t
  } = useLanguage();
  const steps = [{
    num: '1',
    image: 'https://cdn.magicpatterns.com/uploads/bhYsa1hJcQ6d8tbVFjATKW/_Feature_text_(1).png',
    title: t.howItWorks.steps.step1.title,
    desc: t.howItWorks.steps.step1.desc
  }, {
    num: '2',
    image: 'https://cdn.magicpatterns.com/uploads/o7L4cii3yuBxuxzWhCcMor/_Feature_text_(2).png',
    title: t.howItWorks.steps.step2.title,
    desc: t.howItWorks.steps.step2.desc
  }, {
    num: '3',
    image: 'https://cdn.magicpatterns.com/uploads/9XTFjJto4fXP4KWSfoTecG/_Feature_text_(3).png',
    title: t.howItWorks.steps.step3.title,
    desc: t.howItWorks.steps.step3.desc
  }];
  const arrowImg = 'https://cdn.magicpatterns.com/uploads/dcqfGLmkXw9cL557dVU2Tc/arrow_2.png';
  return <section id="how-it-works" className="py-24 bg-gray-50" data-id="element-231">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-232">
        <div className="text-center mb-20" data-id="element-233">
          <p className="text-primary font-bold tracking-widest text-sm uppercase mb-4" data-id="element-234">
            {t.howItWorks.label}
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-text-main" data-id="element-235">
            {t.howItWorks.title}
          </h2>
        </div>

        <div className="flex flex-col md:flex-row items-center md:items-start justify-center gap-6 lg:gap-10 max-w-6xl mx-auto" data-id="element-236">
          {steps.map((step, index) => <Fragment key={index} data-id="element-237">
              <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="relative z-10 flex flex-col items-center text-center flex-1 max-w-[280px]" data-id="element-238">
                {/* Illustration */}
                <div className="relative mb-6" data-id="element-239">
                  <img src={step.image} alt={step.title} className="w-48 h-48 object-contain" data-id="element-240" />
                  {/* Number Badge */}
                  <div className="absolute -top-2 -left-2 w-10 h-10 bg-primary text-white rounded-full flex items-center justify-center font-bold text-lg shadow-md border-4 border-gray-50" data-id="element-241">
                    {step.num}
                  </div>
                </div>

                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-242">
                  {step.title}
                </h3>
                <p className="text-text-muted max-w-xs mx-auto text-sm leading-relaxed" data-id="element-243">
                  {step.desc}
                </p>
              </motion.div>

              {/* Arrow between steps */}
              {index < steps.length - 1 && <motion.div initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2 + 0.3
          }} className="flex items-center justify-center md:pt-20" data-id="element-244">
                  <img src={arrowImg} alt="arrow" className="w-16 md:w-20 h-auto object-contain rotate-90 md:rotate-0" data-id="element-245" />
                </motion.div>}
            </Fragment>)}
        </div>
      </div>
    </section>;
}